import React from 'react';
import { Slide } from '../../types';

export interface StepsCardProps {
  cardData: Slide;
}

const StepsCard = ({ cardData: { step, image, text } }: StepsCardProps) => {
  return (
    <div className="steps-card">
      <h3 className="step-number small-font">Step {step}</h3>
      <div
        className="image-wrapper"
        style={{ backgroundImage: `url(${image})` }}
      />
      <h2 className="heading small-font">{text}</h2>
    </div>
  );
};

export default StepsCard;
